<div class="d-flex align-items-center " style="padding: 20px; gap: 4px;">        
    <div class="mat-body-2">Secció</div>
    <div style="flex:1 0 0;"></div>
    <div>
        <app-chip [hasAction]="false" [label]="'ID: '+item.id" [hasClose]="false"  [filledStyle]="true" ></app-chip>
    </div>
</div>
<mat-divider></mat-divider>

<app-tool-help>
    <mat-icon  class="material-icons-outlined" style="overflow: visible;" helpIcon>{{icon()}}</mat-icon>
    <div helpDesc>{{helpText()}}</div>
</app-tool-help>

<mat-accordion displayMode="flat" [multi]="true">

    <mat-expansion-panel [expanded]="true" class="mat-elevation-z81">
        <mat-expansion-panel-header>

            <mat-panel-description class="mat-body-2" style="color:unset">
                General
            </mat-panel-description>

        </mat-expansion-panel-header>
        <div class="d-flex flex-column">

            <app-single-field label="Nom" toolTipMsg="Introdueix el nom del camp de la secció. Aquest és el títol de la secció que l'usuari veurà en completar el formulari."
             [fieldValue]="item.name" (fieldValueChange)="item.name = $event;fireChange();">                
            </app-single-field>
            
            <app-single-field label="Obligatoria" type="checkbox" toolTipMsg="Marca la secció com d'oblligat ompliment"
            [fieldValue]="item.required" (fieldValueChange)="item.required = $event;fireChange();">                
           </app-single-field>

            <app-single-field label="Amagar capçalera" type="checkbox" toolTipMsg="Permit amagar la capçalera del formulari"
             [fieldValue]="item.hideHeader" (fieldValueChange)="item.hideHeader = $event;fireChange();">                
            </app-single-field>

            <app-single-field label="Visible inicialment" type="checkbox" toolTipMsg="Permet que la secció no sigui visible des de l'inici"
             [fieldValue]="item.shown" (fieldValueChange)="item.shown = $event;fireChange();">                
            </app-single-field>

        </div>

    </mat-expansion-panel>

    <mat-expansion-panel [expanded]="false" class="mat-elevation-z81">
        <mat-expansion-panel-header>
            <mat-panel-description class="mat-body-2" style="color:unset">
                Interoperabilitat
            </mat-panel-description>
        </mat-expansion-panel-header>
        
        <div class="d-flex flex-column">
            <app-single-field label="Nom al JSON" [validator]="fieldNameValidator"
                toolTipMsg="Es el nom que identifica al camp en el format JSON, per tant no pot començar per una lletra, tenir espais i els caràcters han de ser alfanumérics"
                [fieldValue]="item.fieldName" (fieldValueChange)="updatFieldName($event);fireChange();">
            </app-single-field>
        </div>

    </mat-expansion-panel>
    
</mat-accordion>